<template>
  <div>
    <div class="content w">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span v-if="listNews[0]">{{ listNews[0].catName || '资讯' }}</span>
        </div>

        <el-row v-for="(item, index) in listNews" :key="index" class="item">
          <el-col :span="20"
            ><div class="grid_left" @click="toDetail(item.nId)">{{ item.nTitle }}</div></el-col
          >
          <el-col :span="4"
            ><div class="grid_right">{{ item.nAddtime | getDate() }}</div></el-col
          >
        </el-row>
      </el-card>
    </div>

    <!-- 分页 -->
    <div class="car_list w">
      <div class="page_box">
        <el-pagination
          @prev-click="prevPage"
          @next-click="nextPage"
          @current-change="handleCurrentChange"
          :current-page.sync="params.pageNo"
          :page-size="params.pageSize"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import menus from '../utils/menu'
export default {
  data() {
    return {
      params: {
        pageNo: 1,
        pageSize: 25,
        orders: 1,
        catid: '',
        keyword: '',
        isrecom: 0
      },
      listNews: [],
      total: 0
    }
  },
  created() {
    var menuActive = this.$route.name
    if (menuActive == this.$store.state.menuActive) {
    } else {
      var keys = Object.keys(menus)
      if (keys.findIndex(item => item == menuActive) != -1) {
        this.$store.commit('setMenuActive', menuActive)
      }
    }
    var query = this.$route.query
    if (query.catid) {
      this.params.catid = query.catid
    }
    this.getListNews()
  },
  methods: {
    async getListNews() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/news/listNews', {
        params: this.params
      })
      if (data.success) {
        this.listNews = data.data.page.rows
        this.total = data.data.page.recordCount
      }
    },
    toDetail(id) {
      this.$router.push({
        path: '/news-detail',
        query: {
          newsId: id
        }
      })
    },
    handleCurrentChange(page) {
      this.params.pageNo = page
      this.getListNews()
      window.scrollTo(0, 0)
    },
    prevPage(page) {
      this.params.pageNo = page
      this.getListNews()
      window.scrollTo(0, 0)
    },
    nextPage(page) {
      this.params.pageNo = page
      this.getListNews()
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="less" scoped>
.nav_bar {
  background-color: #f5f5f5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.content {
  padding: 20px;

  .item {
    border-bottom: 1px solid #f2f3f4;
    padding: 10px 0;
    color: #888;
    .grid_left:hover {
      cursor: pointer;
      color: #fe834b;
    }
    .grid_right {
      text-align: right;
    }
  }
}
.page_box {
  display: flex;
  justify-content: center;
  padding: 20px;
}
</style>
